import type { PropsWithChildren } from 'react';
import { useCallback, useEffect, useRef } from 'react';

interface Props extends PropsWithChildren {
  block?: ScrollLogicalPosition;
  scrollMarginTop?: number;
  triggerKey?: string; // When this value changes, scroll into view
  disableInitialScroll?: boolean; // Whether to scroll on mount (default: true for backward compatibility)
}

export const WithScrollIntoView = ({
  children,
  block = 'start',
  scrollMarginTop = 100,
  triggerKey,
  disableInitialScroll = false,
}: Props) => {
  const ref = useRef<HTMLDivElement>(null);

  const scrollIntoView = useCallback(() => {
    ref.current?.scrollIntoView({ behavior: 'smooth', block });
  }, [block]);

  useEffect(() => {
    if (!disableInitialScroll) {
      scrollIntoView();
    }
  }, [disableInitialScroll, scrollIntoView]);

  useEffect(() => {
    if (triggerKey !== undefined) {
      scrollIntoView();
    }
  }, [scrollIntoView, triggerKey]);

  return (
    <div ref={ref} style={{ scrollMarginTop }}>
      {children}
    </div>
  );
};
